
export default {
  name: 'submittedDemand',
  data: function data() {
    return {
      activeName: 'index',
      tab: [{
        label: '首页',
        value: 'index'
      }, {
        label: '需求管理',
        value: 'demand'
      }, {
        label: '任务管理',
        value: 'task'
      }]
    };
  },

  methods: {
    handleClick: function handleClick() {
      this.$router.push({
        path: '/butler/submitted-demand/' + this.activeName
      });
    },
    getActiveName: function getActiveName() {
      var _this = this;

      // router/butler.js里面submitted-demand路由中的meta.title与tab.label一致，所以可以以这个title做为判断
      return (this.tab.find(function (item) {
        return item.label === _this.$route.meta.title;
      }) || {}).value;
    }
  },
  watch: {
    $route: function $route(to, from) {
      this.activeName = this.getActiveName();
    }
  },
  mounted: function mounted() {
    this.activeName = this.getActiveName();
  }
};